import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { createUserBanking, getUserBankig, updateUserBanking } from '../../Services/userProfile';
import "./Profile.css"


const UserBank = () => {

    const [formData, setFormData] = useState({
        userId: '',
        accountNumber: '',
        ifscCode: '',
        accountHolderName: '',
        bankName: '',
        bankBranch: '',
        createdBy: '',
    });

    const [PassbookOrChequeImage, setPassbookOrChequeImage] = useState(null);
    const [PassbookOrChequeImagePreview, setPassbookOrChequeImagePreview] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isEditable, setIsEditable] = useState(false);
    const [isBankingFound, setIsBankingFound] = useState(false);

    // Fetch user profile on component mount
    useEffect(() => {
        if (success) {
            // Use Bootstrap's modal API to show the modal
            const modalElement = document.getElementById("success-alert-modal");
            const bootstrapModal = new window.bootstrap.Modal(modalElement);
            bootstrapModal.show();

            // Automatically close the modal after 3 seconds
            setTimeout(() => {
                bootstrapModal.hide();
                setSuccess(false); // Reset success state after hiding the modal
            }, 3000);
        }

        if (error) {
            // Use Bootstrap's modal API to show the modal
            const modalElement = document.getElementById("warning-alert-modal");
            const bootstrapModal = new window.bootstrap.Modal(modalElement);
            bootstrapModal.show();

            // Automatically close the modal after 3 seconds
            setTimeout(() => {
                bootstrapModal.hide();
                setError(false); // Reset success state after hiding the modal
            }, 3000);
        }


        const fetchUserBanking = async () => {
            const user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                setFormData((prevData) => ({
                    ...prevData,
                    userId: user.id,
                    createdBy: user.id,
                }));
                try {
                    const banking = await getUserBankig(user.id);
                    if (banking) {
                        setFormData((prevData) => ({
                            ...prevData,
                            ...banking,
                        }));
                        if (banking.passbookOrChequeImage) {
                            setPassbookOrChequeImage(banking.passbookOrChequeImage);
                        }
                        setIsBankingFound(true);
                        setIsEditable(false); // Disable editing when data is found
                    } else {
                        setIsBankingFound(false);
                        setIsEditable(true); // Enable editing for new data
                    }
                } catch (error) {
                    //console.error('Error fetching profile:', error);
                    setIsBankingFound(false);
                    setIsEditable(true); // Allow editing if there's an error
                }
            }
        };
        fetchUserBanking();
    }, [success,error]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPassbookOrChequeImage(file);

            const reader = new FileReader();
            reader.onload = () => setPassbookOrChequeImagePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = new FormData();
        Object.keys(formData).forEach((key) => {
            if (formData[key]) form.append(key, formData[key]);
        });

        // If a new image is selected, append it to the form
        if (PassbookOrChequeImage) {
            form.append('passbookOrChequeImage', PassbookOrChequeImage); // New image
        }

        try {
            if (isBankingFound) {
                if (PassbookOrChequeImage) {
                    await updateUserBanking(formData.userId, form);
                    setSuccess('Your banking data has been successfully updated!');
                } else {
                    setError('Please select profile picture!');
                }
            } else {
                await createUserBanking(form);
                setSuccess('Your banking data has been successfully inserted!');
                setIsBankingFound(true);
                setIsEditable(false);
            }
            setIsEditable(false);

            // Optionally reset profileImage state if update succeeds
            if (PassbookOrChequeImage) {
                setPassbookOrChequeImage(null);
            }
        } catch (error) {
            setError('');
            setSuccess('');
        }
    };

    const handleUpdateClick = (e) => {
        e.preventDefault();
        setIsEditable(true);
    };

    const handleCancelClick = (e) => {
        e.preventDefault();
        setIsEditable(false);
    };
    return (
        <>
            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">
                                                        Dashboard
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">Banking Details</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">User Details</h4>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="header-title">Banking Details</h4>
                                            {error &&
                                                <div id="warning-alert-modal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                                                    <div className="modal-dialog modal-sm">
                                                        <div className="modal-content">
                                                            <div className="modal-body p-4">
                                                                <div className="text-center">
                                                                    <i className="ri-alert-line h1 text-warning" />
                                                                    <h4 className="mt-2">Incorrect Information</h4>
                                                                    <p className="mt-3">{error}</p>
                                                                    <button type="button" className="btn btn-warning my-2" data-bs-dismiss="modal">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {success && (
                                                <div id="success-alert-modal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                                                    <div className="modal-dialog modal-sm">
                                                        <div className="modal-content modal-filled bg-success">
                                                            <div className="modal-body p-4">
                                                                <div className="text-center">
                                                                    <i className="ri-check-line h1" />
                                                                    <h4 className="mt-2">Well Done!</h4>
                                                                    <p className="mt-3">{success}</p>
                                                                    <button type="button" className="btn btn-light my-2" data-bs-dismiss="modal">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <hr /><hr />
                                            <div className="tab-content">
                                                <div className="tab-pane show active" id="input-types-preview">
                                                    <div className="row">
                                                        <form onSubmit={(e) => e.preventDefault()}>
                                                            <div className="row">
                                                                {/* First Name, Middle Name, Last Name */}
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="accountNumber" className="form-label">Account Number</label>
                                                                    <input
                                                                        type="text"
                                                                        id="accountNumber"
                                                                        name="accountNumber"
                                                                        className="form-control"
                                                                        value={formData.accountNumber}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="ifscCode" className="form-label">IFSC Code</label>
                                                                    <input
                                                                        type="text"
                                                                        id="ifscCode"
                                                                        name="ifscCode"
                                                                        className="form-control"
                                                                        value={formData.ifscCode}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="accountHolderName" className="form-label">Account Holder Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="accountHolderName"
                                                                        name="accountHolderName"
                                                                        className="form-control"
                                                                        value={formData.accountHolderName}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>

                                                                
                                                                {/* Aadhar, PAN, Profile Picture */}
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="bankName" className="form-label">Bank Name</label>
                                                                    <input
                                                                        type="text"
                                                                        id="bankName"
                                                                        name="bankName"
                                                                        className="form-control"
                                                                        value={formData.bankName}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="bankBranch" className="form-label">Bank Branch</label>
                                                                    <input
                                                                        type="text"
                                                                        id="bankBranch"
                                                                        name="bankBranch"
                                                                        className="form-control"
                                                                        value={formData.bankBranch}
                                                                        onChange={handleChange}
                                                                        readOnly={!isEditable}
                                                                    />
                                                                </div>

                                                                <div className="col-md-4 mb-3">
                                                                    
                                                                </div>
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="passbookOrChequeImage" className="form-label">Passbook Or Cheque Image</label>
                                                                    <input
                                                                        type="file"
                                                                        id="passbookOrChequeImage"
                                                                        name="passbookOrChequeImage"
                                                                        className="form-control"
                                                                        onChange={handleFileChange}
                                                                        disabled={!isEditable}
                                                                        accept="image/*"
                                                                    />

                                                                </div>
                                                                <div className="col-md-1 mb-3">
                                                                    {(PassbookOrChequeImagePreview || PassbookOrChequeImage) && (
                                                                        <img
                                                                            src={
                                                                                PassbookOrChequeImagePreview? PassbookOrChequeImagePreview                      // newly selected image
                                                                                    : typeof PassbookOrChequeImage === "string"
                                                                                        ? `https://api.mysfs24.com/${PassbookOrChequeImage.replace(/^(\.\.\/)+/, '')}`: ""}
                                                                            alt="Profile Preview"
                                                                            className="rounded-profile-img mt-3"
                                                                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                                        />
                                                                    )}
                                                                </div>

                                                                {/* Button Group */}
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {!isBankingFound ? (
                                                                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                                                            Submit
                                                                        </button>
                                                                    ) : !isEditable ? (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-info"
                                                                            onClick={handleUpdateClick}
                                                                        >
                                                                            Update
                                                                        </button>
                                                                    ) : (
                                                                        <>
                                                                            <button type="button" className="btn btn-success" onClick={handleSubmit}>
                                                                                Save Changes
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-danger"
                                                                                onClick={handleCancelClick}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div> {/* end col */}
                                                </div>
                                            </div> {/* end preview*/}
                                        </div> {/* end tab-content*/}
                                    </div> {/* end card-body */}
                                </div> {/* end card */}
                            </div>{/* end col */}
                        </div>{/* end row */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserBank
